const parseCookie = (name: string, cookies: string) => {
  const value = `; ${cookies}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length !== 2) return null;

  const cookieValue = parts.pop();
  if (!cookieValue) return null;

  return cookieValue.split(';').shift();
};

const getCookie = (name: string) => parseCookie(name, document.cookie);

const ONE_YEAR_IN_MS = 365 * 24 * 60 * 60 * 1000;
const DEFAULT_MAX_AGE = ONE_YEAR_IN_MS;

const setCookie = (
  name: string,
  value: string,
  options?: {
    maxAge?: number;
    path?: string;
  },
) => {
  const { maxAge = DEFAULT_MAX_AGE, path = '/' } = options || {};
  document.cookie = `${name}=${value};path=${path};max-age=${maxAge}`;
};

const getUtmCookies = () => {
  const [utmCampaign, utmSource, utmMedium, utmContent, utmTerm] = [
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_term',
  ].map(getCookie);

  return { utmCampaign, utmSource, utmMedium, utmContent, utmTerm };
};

export { getCookie, setCookie, getUtmCookies, parseCookie, DEFAULT_MAX_AGE };
